export default __webpack_public_path__ + "static/media/soldering-outline-blue.5894a65d.png";